import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('Page crashed:', error, info);
  }
  render() {
    if (this.state.error) {
      return (
        <div className="min-h-[60vh] flex items-center justify-center p-6">
          <div className="max-w-lg bg-white rounded-xl border border-rose-200 shadow p-6 text-sm">
            <div className="text-rose-700 font-bold mb-2">⚠ Something went wrong on this page</div>
            <div className="text-gray-600 mb-3">{String(this.state.error?.message || this.state.error)}</div>
            <div className="flex gap-2">
              <button onClick={() => { this.setState({ error: null }); window.location.reload(); }}
                className="px-3 py-1.5 rounded bg-slate-900 text-white text-xs">
                Reload page
              </button>
              <button onClick={() => { window.location.href = '/'; }}
                className="px-3 py-1.5 rounded border text-xs">
                Go home
              </button>
            </div>
            <details className="mt-3 text-[10px] text-gray-500">
              <summary className="cursor-pointer">Technical details</summary>
              <pre className="whitespace-pre-wrap mt-1">{String(this.state.error?.stack || '')}</pre>
            </details>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
